import { format } from 'date-fns';
export const HOME_STATUS = {
    not_started: {
        label: 'Not started',
        variant: 'neutral'
    },
    drafting: {
        label: 'Drafting',
        variant: 'warning'
    },
    in_review: {
        label: 'In review',
        variant: 'info'
    },
    final: {
        label: 'Final',
        variant: 'success'
    },
    final_edited: {
        label: 'Edited after final',
        variant: 'warning'
    },
    orphaned: {
        label: 'Heading missing',
        variant: 'danger'
    }
};
/** RFI status badge (header meta). */ export function rfiStatusBadge(status) {
    switch(status){
        case 'submitted':
            return {
                label: 'Submitted',
                variant: 'success'
            };
        case 'closed':
            return {
                label: 'Closed',
                variant: 'neutral'
            };
        default:
            return {
                label: 'Drafting',
                variant: 'info'
            };
    }
}
/** "question 6" / "questions 6 and 9" / "questions 2, 6 and 9". */ export function questionList(numbers) {
    if (numbers.length === 0) return '';
    if (numbers.length === 1) return `question ${numbers[0]}`;
    const head = numbers.slice(0, -1).join(', ');
    return `questions ${head} and ${numbers[numbers.length - 1]}`;
}
function pages(n) {
    return Number.isInteger(n) ? String(n) : n.toFixed(1);
}
/** The four Home KPIs (WRT-06 layout item 3). */ export function homeMetrics(k) {
    const measured = k.pagesBasis === 'exact';
    const pageNote = measured ? 'pages (measured)' : 'pages, at current length';
    return [
        {
            id: 'final',
            label: 'Answers final',
            tone: 'success',
            value: `${k.answersFinal} / ${k.answersTotal}`,
            note: `${k.inReview} in review · ${k.drafting} drafting`,
            info: 'Answers whose current text is the approved text.'
        },
        {
            id: 'no-owner',
            label: 'No owner',
            tone: k.noOwner > 0 ? 'danger' : 'neutral',
            value: String(k.noOwner),
            note: k.noOwner > 0 ? questionList(k.noOwnerQuestionNumbers) : 'every question has an owner',
            info: 'Questions nobody owns yet.'
        },
        {
            id: 'pages',
            label: 'Page limit',
            tone: 'info',
            value: k.pageLimit > 0 ? `${pages(k.pagesEstimate)} / ${pages(k.pageLimit)}` : pages(k.pagesEstimate),
            note: k.pageLimit > 0 ? pageNote : `${pageNote} · set a limit`,
            info: 'Estimated from the answers’ words until exact pages are measured.'
        },
        {
            id: 'days',
            label: 'Days left',
            tone: k.daysLeft >= 0 && k.daysLeft <= 2 ? 'danger' : 'warning',
            value: k.daysLeft < 0 ? '—' : String(k.daysLeft),
            note: k.nextInternalDue ? `internal review on ${format(k.nextInternalDue, 'd MMM')}` : 'no internal review date',
            info: 'Days until the response is due.'
        }
    ];
}
/** Splits a "{{n}}" body into text and link tokens (an unknown placeholder renders as nothing). */ export function tokenizeSignalBody(body, links) {
    const byOrdinal = new Map(links.map((l)=>[
            l.ordinal,
            l
        ]));
    const out = [];
    const re = /\{\{(\d+)\}\}/g;
    let last = 0;
    for(let m = re.exec(body); m; m = re.exec(body)){
        if (m.index > last) out.push({
            kind: 'text',
            text: body.slice(last, m.index)
        });
        const n = Number(m[1]);
        const link = byOrdinal.get(n);
        out.push(link ? {
            kind: 'link',
            link
        } : {
            kind: 'missing',
            ordinal: n
        });
        last = m.index + m[0].length;
    }
    if (last < body.length) out.push({
        kind: 'text',
        text: body.slice(last)
    });
    return out;
}
export const EMAIL_RE = /[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/;
/**
 * Builds the signal template (WRT-06 layout item 6): for each mention in
 * ordinal order the FIRST remaining "@{label}" becomes "{{ordinal}}"; a
 * mention whose text the user deleted is appended as " {{ordinal}}". Text
 * typed without the picker stays plain (never auto-resolved by name).
 */ export function buildSignalTemplate(body, mentions) {
    let out = body;
    const sorted = [
        ...mentions
    ].sort((a, b)=>a.ordinal - b.ordinal);
    for (const m of sorted){
        const needle = `@${m.label}`;
        const i = out.indexOf(needle);
        if (i >= 0) {
            out = `${out.slice(0, i)}{{${m.ordinal}}}${out.slice(i + needle.length)}`;
        } else {
            out = `${out.trimEnd()} {{${m.ordinal}}}`;
        }
    }
    return out;
}
/** Role display names in the rail's group order. */ export const ENTITY_ROLE_LABEL = {
    submission_recipient: 'Send to',
    point_of_contact: 'Point of contact',
    questions_to: 'Questions to',
    issuing_office: 'Issuing office',
    customer_org: 'Customer',
    vehicle: 'Vehicle',
    mentioned: 'Mentioned'
};
export const ENTITY_ROLE_ORDER = Object.keys(ENTITY_ROLE_LABEL);
/** Kinds each role allows (mirrors the DDL CHECKs). */ export const ENTITY_ROLE_KINDS = {
    submission_recipient: [
        'CONTACT',
        'GOVERNMENT_ORG'
    ],
    point_of_contact: [
        'CONTACT'
    ],
    questions_to: [
        'CONTACT'
    ],
    issuing_office: [
        'GOVERNMENT_ORG'
    ],
    customer_org: [
        'GOVERNMENT_ORG'
    ],
    vehicle: [
        'VEHICLE'
    ]
};
